var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
import { commonAttrs } from '../../utils';
import { CFModalWrapperElements } from './ModalWrapper.styles';
import { MODAL_TRANSITION_DURATION, } from '@connectrn/ds-ui-base';
import { CSSTransition } from 'react-transition-group';
export const CFModalWrapperCore = (_a, ref) => {
    var { children, enterFrom, exitTo, id, onClose, onDismiss, onOpen, preventDismiss } = _a, rest = __rest(_a, ["children", "enterFrom", "exitTo", "id", "onClose", "onDismiss", "onOpen", "preventDismiss"]);
    const [active, setActive] = useState(false);
    const { DismissHitspace, Root } = CFModalWrapperElements;
    const open = () => {
        setActive(true);
        if (onOpen)
            onOpen(id);
    };
    const close = (closeOptions) => {
        setActive(false);
        if (onClose)
            onClose(id);
        if (!closeOptions)
            return;
        const { onHide } = closeOptions;
        if (onHide) {
            setTimeout(() => {
                onHide(id);
            }, MODAL_TRANSITION_DURATION);
        }
    };
    const onClickDismissHitspace = () => {
        if (preventDismiss)
            return;
        if (onDismiss)
            onDismiss(id);
    };
    useImperativeHandle(ref, () => {
        return {
            close,
            id,
            open,
            setBody: () => null,
            setFooter: () => null,
            setHeader: () => null, // DEPRECATED
        };
    });
    useEffect(open, []);
    return (React.createElement(CSSTransition, { in: active, timeout: MODAL_TRANSITION_DURATION }, (state) => (React.createElement(Root, Object.assign({ enterFrom: enterFrom, exitTo: exitTo, transitionState: state }, commonAttrs(rest)),
        React.createElement(DismissHitspace, { onClick: onClickDismissHitspace }),
        children))));
};
export const CFModalWrapper = forwardRef(CFModalWrapperCore);
